module.exports = "/_next/static/images/Hero-lg@2x-f1c40067363e3746d8d1a70af39c888e.png";